import { useRoutes, matchRoutes } from "react-router-dom";
import React, { useEffect, useState } from "react";
// project import
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isExpired, decodeToken } from "react-jwt";
import { LOGIN_AUTH, LOGOUT_AUTH } from "store/reducers/auth";
import apiClient from "@api/apiClient";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const userModel = useSelector((state) => state.auth.userModel);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    checkLogin();
  }, [userModel.isLogin, location.pathname]);

  const [access_list_data, setaccess_list_data] = useState([]);

  useEffect(() => {
    if (userModel.isLogin) {
      const storedData = localStorage.getItem("access_list_data");
      if (storedData && storedData !== "undefined" && storedData !== "null") {
        try {
          setaccess_list_data(JSON.parse(storedData));
        } catch (error) {
          console.error("Failed to parse access_list_data:", error);
          localStorage.removeItem("access_list_data");
          setaccess_list_data([]);
        }
      }
    }
  }, [userModel.isLogin]);

  // Validate token with server (checks if blacklisted due to SSO logout)
  async function validateTokenWithServer() {
    const token = localStorage.getItem("Token");
    if (!token) return false;

    try {
      // Make a simple API call to check if token is still valid
      // The apiClient interceptor will handle 401 and redirect to Auth login
      await apiClient.get("/api/token/verify/", { data: { token } });
      return true;
    } catch {
      // 401 is handled by apiClient interceptor (clears localStorage, redirects)
      return false;
    }
  }

  function checkLogin() {
    const token = localStorage.getItem("Token");
    const isMyTokenExpired = isExpired(token);

    if (!userModel.isLogin) {
      if (
        (location.pathname !== "/login" || location.pathname !== "/") &&
        isMyTokenExpired
      ) {
        const loginRoutes = [LoginRoutes()];
        const matchedRoutes = matchRoutes(loginRoutes, location.pathname);
        matchedRoutes
          ? navigate({
              pathname: location.pathname,
              search: location.search,
              hash: location.hash,
            })
          : navigate("/login");
        localStorage.setItem("lang", "en");
      }
    } else if (isMyTokenExpired && userModel.isLogin) {
      dispatch(LOGOUT_AUTH());
      navigate("/login");
    } else if (
      (location.pathname === "/login" || location.pathname === "/") &&
      !isMyTokenExpired
    ) {
      // Validate token with server before allowing access
      validateTokenWithServer();
      dispatch(LOGIN_AUTH());
      navigate("/tickets");
    } else {
      // Validate token with server on each route change
      validateTokenWithServer();
      dispatch(LOGIN_AUTH());
    }
  }

  return useRoutes([
    LoginRoutes(),
    userModel.isLogin && MainRoutes(access_list_data),
  ]);
}
